import {addAuthToFetchOpts} from '../config/queryopts'
import {useMutationWithAuthentication} from "./index";
import {apiUrlInternal} from "../config/api"
import axios from "axios";
import {useQueryClient} from "react-query";


export const DeleteRetroHuntTaskFetcher = (uid, accessToken) => {
  return axios.delete(`${apiUrlInternal}/retrohunt/tasks/${uid}`, addAuthToFetchOpts(accessToken, {})).then(res => res.data );
}

export const useDeleteRetroHuntTask = (fetcher = DeleteRetroHuntTaskFetcher) => {
  const queryClient = useQueryClient();
  return useMutationWithAuthentication(
    ['delete-retrohunt-tasks'],
    (accessToken, uid) => fetcher(uid, accessToken),
    {onSuccess: () => queryClient.invalidateQueries('delete-retrohunt-tasks')}
  )
}
